'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  const modal = $('#alert-modal');
  const toastContainer = $('#alert-toast-container');
  const storageKey = 'alertDismissed';
  const modalStorageKey = 'modalDismissed';
  const dismissBtn = $('#alert-toast-container button');

  // Show modal on load, unless dismissed permanently
  if (!localStorage.getItem(storageKey)) {
    if (localStorage.getItem(modalStorageKey)) {
      // show the dismissed modal (toast) if the modal was dismissed
      modal.modal('hide');
      toastContainer.show();
    } else {
      modal.modal('show');
    }
  }

  // On dismiss, hide the toast and permanently dismiss
  dismissBtn.on('click', function () {
    toastContainer.hide();
    localStorage.setItem(storageKey, true);
  });

  // On modal close, show the toast
  modal.on('hidden.bs.modal', function () {
    localStorage.setItem(modalStorageKey, true);
    toastContainer.fadeIn();
  });

})(jQuery);
